module.exports = __webpack_public_path__ + "media/images/formbeat-sign-666dd7bd.svg";